import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import { checkAuth } from '@/store/modules/authentication'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    redirect: {
      name: 'dashboard'
    },
    component: () => import('@/views/index.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: 'Dashboard'
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue')
      },
      {
        path: '/blog',
        name: 'blog',
        children: [
          { path: 'post', name: 'post', component: () => import(/* webpackChunkName: "postIndex" */ '@/views/blog/post/index.vue') },
          { path: 'post/:id', name: 'postId', component: () => import(/* webpackChunkName: "postId" */ '@/views/blog/post/[id]/index.vue') },
          { path: 'comment', name: 'comment', component: () => import(/* webpackChunkName: "commentIndex" */ '@/views/blog/comment/index.vue') },


        ],
        component: () => import(/* webpackChunkName: "blog" */'@/views/blog/index.vue')

      },
      {
        path: '/post-category',
        name: 'post-category',
        children: [
          { path: 'management', name: 'post-category-management', component: () => import(/* webpackChunkName: "postIndex" */ '@/views/post-category/index.vue') },
          { path: ':id', name: 'post-category-id', component: () => import(/* webpackChunkName: "postId" */ '@/views/post-category/[id]/index.vue') },

        ],
      },
      {
        path: '/messages',
        name: 'messages',
        component: () => import(/* webpackChunkName: "postIndex" */ '@/views/messages/index.vue'),
        children: [
          // {path: '/', name: 'messages',},
          { path: ':id', name: 'messages-id', component: () => import(/* webpackChunkName: "postId" */ '@/views/messages/[id]/index.vue') },

        ],
      },

      {
        path: '/statistics', name: 'statistics', component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/index.vue'),
      },
      {
        path: '/statistics/blocked', name: 'statisticsBlocked', component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/Blocked.vue'),
      },
      {
        path: '/statistics/solfege-app', name: 'statisticsSolfegeApp', component: () => import(/* webpackChunkName: "statisticsSolfegeApp" */ '@/views/statistics/solfege-app/index.vue'),
      },
      {
        path: '/static-pages',
        name: 'static-pages',
        component: () => import(/* webpackChunkName: "postIndex" */ '@/views/static-pages/index.vue'),
        // children: [

        // ],
      },
      { path: '/static-pages/:id', name: 'static-pages-id', component: () => import(/* webpackChunkName: "postId" */ '@/views/static-pages/[id].vue') },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach(async (to, from) => {


  if (to.path == '/login') return true
  else {

    const isAllowed = await checkAuth();
    if (!isAllowed) {
      router.push('/login')
      return false
    } else return true
  }
})

export default router
